import { render, staticRenderFns } from "./Chiqim.vue?vue&type=template&id=0ce091a3&scoped=true"
import script from "./Chiqim.vue?vue&type=script&lang=js"
export * from "./Chiqim.vue?vue&type=script&lang=js"
import style0 from "./Chiqim.vue?vue&type=style&index=0&id=0ce091a3&prod&lang=css"
import style1 from "./Chiqim.vue?vue&type=style&index=1&id=0ce091a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce091a3",
  null
  
)

export default component.exports